/**
 * Alert Component - Component Definition
 * =========================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { AlertController } from './controller';
import { ALERT_TEMPLATE } from './template';
import { THEME_CLASSES, BASE_CLASSES, ICONS, DISMISS_ICON, DEFAULTS, AlertTheme, AlertIconType } from './constants';

export interface IAlertComponentBindings {
  theme?: AlertTheme;
  title?: string;
  description?: string;
  showTitle?: boolean;
  showIcon?: boolean;
  icon?: AlertIconType;
  showDismiss?: boolean;
  onDismiss?: (args: { $event: Event }) => void;
}

export const alertComponentDefinition: IComponentOptions = {
  template: ALERT_TEMPLATE,
  controller: AlertController,
  // Slots nombrados — `ecAlertTitle`/`ecAlertText`/`ecAlertActions` son
  // marcadores sin componente propio (mismo criterio que `<ec-label>` en los
  // form controls): el padre los captura y les aplica su propio layout.
  transclude: {
    titleSlot: '?ecAlertTitle',
    textSlot: '?ecAlertText',
    actionsSlot: '?ecAlertActions'
  },
  bindings: {
    theme: '@',
    title: '@',
    description: '@',
    showTitle: '<',
    showIcon: '<',
    icon: '@',
    showDismiss: '<',
    onDismiss: '&?'
  }
};

export const MODULE_NAME = 'ec.alert';

const alertModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecAlert', alertComponentDefinition);

export { AlertController, ALERT_TEMPLATE, THEME_CLASSES, BASE_CLASSES, ICONS, DISMISS_ICON, DEFAULTS };

export type { AlertTheme, AlertIconType } from './constants';

export default alertModule;
